import axios from 'axios';
export async function getTrustChainData(userName) {
    const response = await axios.get(`/api/assignment/trustChain/${userName || ''}`);
    return response.data;
}
